import graphqlClient from '@/graphql/graphql-client';
import { toScalarListVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  GetUserProfilesDocument,
  type GetUserProfilesQuery,
} from '@/graphql/generated/graphql';

export type UserProfileItem = NonNullable<
  NonNullable<GetUserProfilesQuery['getUserProfiless']>['items']
>[number];
export type GetUserProfilesResponse = GetUserProfilesQuery;

export const useGetUserProfiles = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { blocksUserId: 'BlocksUserId' });
  return useQuery({
    queryKey: ['user-profiles', variables],
    queryFn: () => graphqlClient.request(GetUserProfilesDocument, variables),
  });
};

export const requestUserProfiles = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { blocksUserId: 'BlocksUserId' });
  return graphqlClient.request(GetUserProfilesDocument, variables);
};

export const requestUserProfileByUserId = async (userId: string) => {
  const data = await requestUserProfiles({
    where: { BlocksUserId: { eq: userId } },
    paging: { pageNo: 1, pageSize: 1 },
  });
  return data.getUserProfiless?.items?.[0] ?? null;
};

export const GET_USER_PROFILES_QUERY = GetUserProfilesDocument;

